import { render, staticRenderFns } from "./DocumentSignatureView.vue?vue&type=template&id=737b67b3&scoped=true"
import script from "./DocumentSignatureView.vue?vue&type=script&lang=ts"
export * from "./DocumentSignatureView.vue?vue&type=script&lang=ts"
import style0 from "./DocumentSignatureView.vue?vue&type=style&index=0&id=737b67b3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737b67b3",
  null
  
)

export default component.exports